

// document.addEventListener('click', function(event) {
//   if (event.target.matches('fieldset.js.product-form__input.product-form__input--pill.custom_Flavor label')) {
//     var flavor = event.target.getAttribute('value');
//     console.log(flavor);
//   }
// });

// $(document).ready(function() {
//   $("fieldset.js.product-form__input.product-form__input--pill.custom_Size label").on("click", function() {
//     $("fieldset.js.product-form__input.product-form__input--pill.custom_Size label").removeClass("checked");
//     $(this).addClass("checked");
//   });
//   $("fieldset.js.product-form__input.product-form__input--pill.custom_Flavor label").on("click", function() {
//     $("fieldset.js.product-form__input.product-form__input--pill.custom_Flavor label").removeClass("checked");
//     $(this).addClass("checked");
//   });
// });


// $(document).ready(function(){
//   $("fieldset.js.product-form__input.product-form__input--pill.custom_Flavor label, fieldset.js.product-form__input.product-form__input--pill.custom_Size label").on("click", function(){

//     var flavor = $("fieldset.js.product-form__input.product-form__input--pill.custom_Flavor label.checked").attr('value');
//     var size = $("fieldset.js.product-form__input.product-form__input--pill.custom_Size label.checked").attr('value');
//     var combine = flavor + " " + size;
//         combine = combine.toLowerCase();
//         combine = combine.replace(/\s+/g, '');
//         //console.log(combine);


// $(".thumbnail-slider ul.thumbnail-list li img").each(function() {
//     var thumbimg = $(this).attr('alt');
//         thumbimg = thumbimg.toLowerCase();
//         thumbimg = thumbimg.replace(/\s+/g, '');
//         // alert(thumbimg);
        
//       if (combine == thumbimg) {
//        //$(this).css("display", "block");
//         $(this).closest('.thumbnail-list__item').show();
//         console.log(thumbimg+'///'+combine)
//       }else{
//       //$(this).css("display", "none");
//          $(this).closest('.thumbnail-list__item').hide();
//       };
// });
//   });
// });

$(document).ready(function() {
 $("select.select__select.Flavor").on("change", function() {
    $("select.select__select.Flavor option").removeClass("checked");
    $(this).find("option:selected").addClass("checked");
});

 $("select.select__select.Size").on("change", function() {
    $("select.select__select.Size option").removeClass("checked");
    $(this).find("option:selected").addClass("checked");
});
});


$(document).ready(function(){
  $("select.select__select.Flavor, select.select__select.Size").on("change", function(){
 var productName = $(".product__info-wrapper .product__title h1").text();   
    // alert(productName)
    if (productName === "COLLAGEN + MCT OIL"){
      console.log(productName);
    var flavoroption = $("select.select__select.Flavor option.checked").attr('value');
    var sizeoption = $("select.select__select.Size option.checked").attr('value');
    var combineop = flavoroption + " " + sizeoption;
        combineop = combineop.toLowerCase();
        combineop = combineop.replace(/\s+/g, '');
        
$(".thumbnail-slider ul.thumbnail-list li img").each(function() {
    var thumbimg = $(this).attr('alt');
        thumbimg = thumbimg.toLowerCase();
        thumbimg = thumbimg.replace(/\s+/g, '');
        // alert(thumbimg);
      if (combineop == thumbimg) {
       //$(this).css("display", "block");
        $(this).closest('.thumbnail-list__item').show();
        console.log(thumbimg+'///'+combineop)
      }else{
      //$(this).css("display", "none");
         $(this).closest('.thumbnail-list__item').hide();
      };
});
      };
  });
});


// -------------- product page quantity js --------------

$(document).on('change', 'select.product-select_quantity.qnty_cstm', function() {
    var selectedValue = $(this).val();
    $('quantity-input.quantity input.quantity__input').val(selectedValue);
});

$(document).ready(function() {
  $('.rating-wrapper .rating').on('click', function(e) {
    e.preventDefault(); // Prevent default behavior

    var target = $('#judgeme_product_reviews');
    var targetOffset = target.offset().top;

    var scrollToPosition = targetOffset + 300;

    $('html, body').animate({
      scrollTop: scrollToPosition
    }, 800);
  });
});



$(document).on('click', '.custom-message span', function() {
    $('.announcement_bar-popup-wrapper').css({
        'opacity': '1',
        'visibility': 'visible'
    });
})
//   .on('mouseleave', '.custom-message', function() {
//     $('.announcement_bar-popup-wrapper').css({
//         'opacity': '0',
//         'visibility': 'hidden'
//     });
// });


// -----------announcebar popup js

$(document).ready(function () {
  $(document).on('click', '.announcement_bar-popup_text p.announcement-bar__message.h5 .cstm-one', function () {
    $('body').addClass('overlay-hidden');
    $('.announcement_bar-popup-wrapper').css({'opacity': '1', 'visibility': 'visible'});
  });
  $(document).on('click', '.announcement_bar-popup-close', function () {
    $('body').removeClass('overlay-hidden');
    $('.announcement_bar-popup-wrapper').css({'opacity': '0', 'visibility': 'hidden'});
  });
});




// var HeaderMenu_subscribe_save = document.getElementById("HeaderMenu-subscribe-save");
// console.log("HeaderMenu_subscribe_save", HeaderMenu_subscribe_save);
// var offset = 88; 
// if(HeaderMenu_subscribe_save){
//   HeaderMenu_subscribe_save.addEventListener("click", function(event) {
//     event.preventDefault();
//     var targetSection = document.getElementById("shopify-section-template--16067313074289__subscribe_RtATAk");
//        if (targetSection) {
//         var targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - offset;
  
//         window.scrollTo({
//           top: targetPosition,
//           behavior: "smooth"
//         });
//       } else {
//         console.log("Target section not found!");
//       }
//   })
// }







